import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// In production builds, strip verbose console output so debug information
// doesn't leak into end users' devtools. Errors are kept for incident triage.
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
